import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import i18n from 'i18n-react';

import './FlightChangeHeader.css';

const propTypes = {
  passengers: PropTypes.object
};

class FlightChangeSelectionHeader extends React.Component {
  render() {
    return (
      <header className="FlightChangeSelectionHeader">
        <Row>
          <Col>
            <h1>{i18n.translate('features.flightChange.title')}</h1>
          </Col>
        </Row>

        {this.props.passengers.map((passenger, key) => (
          <Row key={`passenger-row-${key}`}>
            <Col md={4} className="no-padding">
              <h2>{i18n.translate('features.flightChange.passenger')}</h2>
              <p>{`${passenger.name} ${passenger.lastName}`}</p>
            </Col>
            <Col md={6} />
            <Col md={4}>
              <h2>{i18n.translate('features.flightChange.ticketNumber')}</h2>
              <p>{passenger.ticketNumber}</p>
            </Col>
            <Col md={6}>
              <h2>{i18n.translate('features.flightChange.baggage')}</h2>
              <p className="baggage">
                {passenger.baggage > 1 || passenger.baggage === 0
                  ? i18n.translate('components.baggage.quantity.many', {
                      quantity: passenger.baggage
                    })
                  : i18n.translate('components.baggage.quantity.single')}
              </p>
            </Col>
          </Row>
        ))}
      </header>
    );
  }
}

FlightChangeSelectionHeader.propTypes = propTypes;

export default FlightChangeSelectionHeader;



// WEBPACK FOOTER //
// ./src/page/flightChangeSelection/components/FlightChangeSelectionHeader/index.jsx